<div class="gauge-wrapper">
    <div [class.no-marker]="!shouldShowMarker"
         [style.--gauge-width]="progressWidth$ | async"
         [style.--gauge-color]="color"
         [style.--gauge-value]="'\'' + (value | number:'1.0-2') + '%\''"
         class="gauge-progress marker-position-{{ markerPosition | lowercase }}"></div>
</div>
